import * as actionTypes from "./register.actionTypes";

export default function reducer(state = {}, action) {
  switch (action.type) {
    case actionTypes.REGISTER_ASYNC.REQUESTED:
      return {
        ...state,
        success: false
      };
    case actionTypes.REGISTER_ASYNC.RECEIVED:
      return {
        ...state,
        success: true,
        error: null
      };
    case actionTypes.REGISTER_ASYNC.ERROR:
      return {
        ...state,
        success: false,
        error: action.payload
      };
    case actionTypes.RESET:
      return {
        ...state,
        success: false,
        error: null
      };
    default:
      return state;
  }
}
